import {useProjectForm} from "../../../providers/ProjectFormProvider";
import React, {useState} from "react";
import {Affix} from "antd";
import FlipMove from "react-flip-move";
import InfoTooltip from "../../../components/InfoTooltip";
import SkillFormButton from "../../talent-application/components/SkillFormButton";

const MAX_ROLES_VISIBLE = 8;
const MAX_SKILLS_VISIBLE = 7;
const MAX_INDUSTRIES_VISIBLE = 8;

const TeamBlueprint = ({components = {roles: true, skills: true, industries: true}, ...props}) => {
    const {
        formModel: project,
        isProjectUpdating,
    } = useProjectForm();

    const isDisabled = props.isDisabled || isProjectUpdating;

    const [affix, setAffix] = useState(false);

    const desiredDeliverables = TB.filter(TB.flatMap(TB.flatMap(project.phases, 'deliverables')), del => del.is_desired !== false)
    const matchedProjectDisciplines = TB.orderBy(TB.reduce(desiredDeliverables, (result, deliverable) => {
        TB.map(TB.flatMap(deliverable.activities, 'disciplines'), dis => {

            let record = {
                ...dis,
                deliverable_id: deliverable.id,
                is_required: deliverable.is_required
            };
            let existingIndex = TB.findIndex(result, ['id', dis.id]);

            if (!result[existingIndex]) {
                result.push(record)
            }else if (!result[existingIndex].is_required && deliverable.is_required) {
                result[existingIndex] = record;
            }
        })
        return result;
    }, []), ['is_required', 'id'], ['desc', 'desc']);

    const hasRequiredDiscipline = TB.find(matchedProjectDisciplines, ['is_required', true]);

    const matchedProjectSkills = TB.orderBy(TB.reduce(desiredDeliverables, (result, deliverable) => {
        TB.map(deliverable.skills, skill => {
            if (!TB.find(result, ['id', skill.id])) {
                result.push({
                    ...skill,
                    deliverable_id: deliverable.id
                })
            }
        })
        return result;
    }, project.skills || []), 'id')


    return (
        <div className="bg-white team-blueprint flex flex-col items-stretch divide-y">
            {props.children}
            <Affix offsetTop={-1} style={{zIndex: 25}} onChange={setAffix}>
                <div
                    className={TB.mapClass("flex flex-row items-stretch divide-x bg-white transition-all", {"drop-shadow": affix})}>
                    <div
                        className="px-7 py-8 flex flex-row gap-5 self-start items-center flex-nowrap justify-center">
                        <i className="fas fa-fingerprint fa-3x text-secondary"/>
                        <div className="flex flex-col gap-0 5">
                            <p className="text-base font-semibold whitespace-nowrap">My Team Blueprint</p>
                            <p className="text-xxs font-medium">Powered by GPT4</p>
                        </div>
                    </div>
                    <div
                        className="flex-grow px-5 py-5 flex flex-col gap-6 items-stretch justify-center">

                        <div className="flex flex-col items-stretch gap-4">
                            {components.roles && (
                                <div
                                    className="flex flex-row justify-start items-stretch pl-5 self-stretch relative gap-4">
                                    <div className="min-h-[28px] pt-[5px] min-w-[85px] max-w-[85px] flex flex-col items-end justify-start">
                                        <p className="text-[11px] font-medium text-gray-400 leading-[18px] text-right">
                                            Team Roles
                                        </p>
                                    </div>
                                    <div className="flex-grow relative flex flex-col items-stretch">
                                        <div className="flex relative flex-row flex-wrap gap-x-2 gap-y-1.5">
                                            <FlipMove typeName={null} maintainContainerHeight={true}>
                                                {matchedProjectDisciplines?.length > 0 ? (
                                                    <React.Fragment>
                                                        {TB.map(TB.take(matchedProjectDisciplines, MAX_ROLES_VISIBLE), dis => (
                                                            <p key={`pro-dis-${dis.id}`}
                                                               className="whitespace-nowrap bg-white border-gray-400 h-[28px] border text-xs rounded-full px-2.5 inline-flex flex-row items-center flex-nowrap gap-1.5"
                                                            >
                                                                <i className="text-success fas fa-user text-[14px]"/>
                                                                <span className="whitespace-nowrap">
                                                                    {dis.name} {dis.is_required && ' *'}
                                                                </span>
                                                            </p>
                                                        ))}
                                                        {matchedProjectDisciplines?.length > MAX_ROLES_VISIBLE && (
                                                            <p className="select-none font-semibold flex flex-col items-start justify-center bg-warning text-xs italic whitespace-nowrap h-[28px] rounded-full px-2.5 text-white"
                                                               key={"role-more"} id={"role-more"}>
                                                                + {matchedProjectDisciplines.length - MAX_ROLES_VISIBLE} more...
                                                            </p>
                                                        )}
                                                    </React.Fragment>
                                                ) : (
                                                    <p key={`pro-dis-none`}
                                                       className="text-[12px] h-[28px] font-medium text-gray-600 leading-[28px]">
                                                        None
                                                    </p>
                                                )}
                                            </FlipMove>

                                            {matchedProjectDisciplines?.length > MAX_ROLES_VISIBLE && (
                                                <InfoTooltip target={"role-more"} type="dark" placement="right">
                                                    <div className="flex flex-col gap-1.5 items-start">
                                                        {TB.map(TB.takeRight(matchedProjectDisciplines, matchedProjectDisciplines.length - MAX_ROLES_VISIBLE), dis => (
                                                            <p key={dis.id} className="m-0 p-0 text-xs text-white">
                                                                {dis.name}
                                                            </p>
                                                        ))}
                                                    </div>
                                                </InfoTooltip>
                                            )}
                                        </div>

                                        {hasRequiredDiscipline && (
                                            <span className="text-xxs italic mt-3 mb-1">
                                                * Required Role
                                            </span>
                                        )}

                                    </div>
                                </div>
                            )}
                            {components.skills && (
                                <div
                                    className="team-skills-container flex flex-row justify-start items-stretch pl-5 self-stretch relative gap-4">
                                    <div className="min-h-[28px] pt-[5px] min-w-[85px] max-w-[85px] flex flex-col items-end justify-start">
                                        <p className="text-[11px] font-medium text-gray-400 leading-[18px] text-right">
                                            Team Skills
                                    </p></div>
                                    {matchedProjectSkills?.length > 0 ? (
                                        <div
                                            className="flex-grow relative discipline-skills-container skill-importance-container">

                                            <FlipMove typeName={null} maintainContainerHeight={true}>
                                                <React.Fragment>
                                                    {TB.map(TB.take(matchedProjectSkills, MAX_SKILLS_VISIBLE), skill => (
                                                        <SkillFormButton
                                                            key={`pro-skilll-${skill.name}`}
                                                            className="whitespace-nowrap pointer-events-none"
                                                            valuePropName={'importance'}
                                                            selected={true}
                                                            removeDisabled={true}
                                                            editDisabled={true}
                                                            disabled={true}
                                                            scoringOptions={laravel.importance_levels}
                                                            skill={skill}
                                                        />
                                                    ))}

                                                    {matchedProjectSkills?.length > MAX_SKILLS_VISIBLE && (
                                                        <p className="select-none font-semibold self-center flex flex-col items-start justify-center bg-warning text-xs italic whitespace-nowrap h-[28px] rounded-full px-2.5 text-white"
                                                           key={"role-more"} id={"skills-more"}>
                                                            + {matchedProjectSkills.length - MAX_SKILLS_VISIBLE} more...
                                                        </p>
                                                    )}
                                                </React.Fragment>
                                            </FlipMove>

                                            {matchedProjectSkills?.length > MAX_SKILLS_VISIBLE && (
                                                <InfoTooltip target={"skills-more"} type="dark" placement="top">
                                                    <div className="flex flex-col gap-1.5 items-start">
                                                        {TB.map(TB.takeRight(matchedProjectSkills, matchedProjectSkills.length - MAX_SKILLS_VISIBLE), skill => (
                                                            <p key={skill.id} className="m-0 p-0 text-xs text-white">
                                                                {skill.name}
                                                            </p>
                                                        ))}
                                                    </div>
                                                </InfoTooltip>
                                            )}
                                        </div>
                                    ) : (
                                        <p className="text-[12px] h-[28px] font-medium text-gray-600 leading-[28px]">
                                            None
                                        </p>
                                    )}


                                </div>
                            )}
                            {components.industries && (
                                <div
                                    className="team-skills-container flex flex-row justify-start items-stretch pl-5 self-stretch relative gap-4">
                                    <div className="min-h-[28px] pt-[5px] min-w-[85px] max-w-[85px] flex flex-col items-end justify-start">
                                        <p className="text-[11px] font-medium text-gray-400 leading-[18px] text-right">
                                            Team Industry Exp
                                    </p></div>
                                    {project.industries?.length > 0 ? (
                                        <div
                                            className="flex-grow relative discipline-skills-container skill-importance-container">

                                            <FlipMove typeName={null} maintainContainerHeight={true}>
                                                <React.Fragment>
                                                    {TB.map(TB.take(project.industries, MAX_INDUSTRIES_VISIBLE), skill => (
                                                        <SkillFormButton
                                                            key={`pro-skilll-${skill.name}`}
                                                            className="whitespace-nowrap pointer-events-none"
                                                            valuePropName={'importance'}
                                                            selected={true}
                                                            removeDisabled={true}
                                                            editDisabled={true}
                                                            disabled={true}
                                                            scoringOptions={laravel.importance_levels}
                                                            skill={skill}
                                                        />
                                                    ))}

                                                    {project.industries?.length > MAX_INDUSTRIES_VISIBLE && (
                                                        <p className="select-none font-semibold self-center flex flex-col items-start justify-center bg-warning text-xs italic whitespace-nowrap h-[28px] rounded-full px-2.5 text-white"
                                                           key={"role-more"} id={"skills-more"}>
                                                            + {project.industries.length - MAX_INDUSTRIES_VISIBLE} more...
                                                        </p>
                                                    )}
                                                </React.Fragment>
                                            </FlipMove>

                                            {project.industries?.length > MAX_INDUSTRIES_VISIBLE && (
                                                <InfoTooltip target={"skills-more"} type="dark" placement="top">
                                                    <div className="flex flex-col gap-1.5 items-start">
                                                        {TB.map(TB.takeRight(project.industries, project.industries.length - MAX_INDUSTRIES_VISIBLE), skill => (
                                                            <p key={skill.id} className="m-0 p-0 text-xs text-white">
                                                                {skill.name}
                                                            </p>
                                                        ))}
                                                    </div>
                                                </InfoTooltip>
                                            )}
                                        </div>
                                    ) : (
                                        <p className="text-[12px] h-[28px] font-medium text-gray-600 leading-[28px]">
                                            None
                                        </p>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Affix>
        </div>
    )
}

export default TeamBlueprint